import { render } from "./NavBar.vue?vue&type=template&id=672fe109"
import script from "./NavBar.vue?vue&type=script&lang=ts"
export * from "./NavBar.vue?vue&type=script&lang=ts"

import "./NavBar.vue?vue&type=style&index=0&id=672fe109&lang=scss"
script.render = render

export default script